
export interface TaxInvoiceData {
  // Buyer information
  buyerCompanyName: string;
  buyerAddress: string;
  buyerCity: string;
  buyerPostalCode: string;
  buyerVatNumber: string;
  buyerCrNumber?: string;
  
  // Pre-filled from campaign
  companyName: string;
  brandName: string;
  contactPerson: string;
  email: string;
  mobile: string;
  
  // Campaign details
  campaignId: string;
  locations: LocationItem[];
  duration: number;
  
  // Financial
  subtotal: number;
  vatAmount: number;
  totalAmount: number;
  amountPaid: number;
  remainingBalance: number;
  
  // Invoice metadata
  invoiceNumber: string;
  invoiceDate: string;
  paymentMethod: 'creditcard' | 'bank_transfer';
}

export interface LocationItem {
  name: string;
  days: number;
  pricePerDay: number;
  total: number;
}

export interface GeneratedInvoice {
  invoiceNumber: string;
  pdfBase64: string;
  pdfUrl?: string;
}

export interface TaxInvoiceFormData {
  buyerAddress: string;
  buyerCity: string;
  buyerPostalCode: string;
  buyerVatNumber: string;
  buyerCrNumber: string;
}

// Seller (Fusion Media) constants
export const SELLER_INFO = {
  name: 'FUSION MEDIA',
  nameAr: 'شركة الانصهار للدعاية والاعلان',
  // Keep this Latin/English to avoid jsPDF glyph corruption in the generated PDF
  address: 'Al Yasmin District, Abdullah Abdulrahman St.',
  addressAr: 'حي الياسمين, شارع عبدالله عبدالرحمن',
  city: 'الرياض',
  cityEn: 'Riyadh',
  postalCode: '13325',
  country: 'المملكة العربية السعودية',
  countryEn: 'Kingdom of Saudi Arabia',
  vatNumber: '312853695800003'
};
